(function configMenuModule() {

    'use strict';

    angular.module("ConfigMenu", ['NavMenu'])
        .run([
            'navMenu', 'authExtend', function configMenuRun(navMenu, auth) {

                function mnuProfileItems(userOu) {
                    var items = [
                        {
                            condition: function () {
                                return (auth.isLogged() && (userOu != null && userOu.length > 0 ? !userOu[0].isLDAP : true));
                            },
                            text: 'ChangePassword',
                            state: 'change-password'
                        },
                        {
                            condition: function () {
                                return (auth.isInRole('USERIMPERSONATION WRITE'));
                            },
                            text: 'UserImpersonation',
                            state: 'user-impersonation'
                        },
                        {
                            condition: function () {
                                return (auth.isLogged());
                            },
                            text: 'Profile',
                            state: 'profile-detail'
                        },
                        {
                            condition: function () {
                                return (auth.getOrganizationId() !== '' &&
                                    (auth.isInRole('CERTIFICATECUSTOMER WRITE')));
                            },
                            text: 'ProfileAddCertificate',
                            state: 'profile-add-certificate'
                        },

                    ];

                    if (userOu != null) {
                        userOu.forEach(function (user) {
                            if (user.organizationalUnit.name != auth.getOrganizationName()) {
                                if (user.enabled) {
                                    var item = {
                                        condition: function () {
                                            return (auth.isLogged());
                                        },
                                        text: user.organizationalUnit.name,
                                        state: 'inicio-changeuser', keyview: user.userId
                                    };
                                    items.push(item);
                                } else {
                                    var item = {
                                        condition: function () {
                                            return (auth.isLogged());
                                        },
                                        text: user.organizationalUnit.name + "( Deshabilitado )"
                                    };
                                    items.push(item);
                                }
                            }
                        });
                    }

                    return items;
                }

                function menu() {
                    navMenu.clear();

                    if (auth.isLogged()) {
                        navMenu.setUserMenuItems(mnuProfileItems(auth.getUsers()));
                    } else {
                        navMenu.setUserMenuItems(mnuProfileItems(null));
                    }

                    navMenu.addItem({
                        condition: function () {
                            return (auth.isLogged());
                        },
                        text: 'MenuHome',
                        state: 'inicio'
                    }, -1);

                    navMenu.addItem({
                        condition: function () {
                            return (
                                auth.isInRole('LAWBOOK READ') ||
                                auth.isInRole('LAWBOOK WRITE'));
                        },
                        text: 'MenuLawBook',
                        state: 'lawbook-find'
                    }, -1);

                    navMenu.addItem({
                        condition: function () {
                            return (
                                auth.isInRole('ROLE READ') ||
                                auth.isInRole('ROLE WRITE') ||
                                auth.isInRole('ORGANIZATIONALUNIT READ') ||
                                auth.isInRole('ORGANIZATIONALUNIT WRITE') ||
                                auth.isInRole('USER READ') ||
                                auth.isInRole('USER WRITE') ||
                                auth.isInRole('AUDIT READ') ||
                                auth.isInRole('RSD') ||
                                auth.isInRole('RRHH_CONTENT') ||
                                auth.isInRole('PROCESS ASYNC') ||
                                auth.isInRole('ENABLE ARANDANOS UI')
                            );
                        },
                        text: 'MenuAdmin',
                        items: [
                            {
                                condition: function () {
                                    return (auth.isInRole('AUDIT READ') || auth.isInRole('RSD') || auth.isInRole('RRHH_CONTENT'));
                                },
                                text: 'MenuAudit',
                                state: 'audit-find'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('ROLE READ') || auth.isInRole('ROLE WRITE'));
                                },
                                text: 'MenuRole',
                                state: 'role-find'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('USER READ') || auth.isInRole('USER WRITE'));
                                },
                                text: 'MenuUser',
                                state: 'user-find'
                            },
                            {
                                condition: function () {
                                    return (auth.isInRole('ORGANIZATIONALUNIT READ') || auth.isInRole('ORGANIZATIONALUNIT WRITE'));
                                },
                                text: 'MenuOrganizationalUnit',
                                state: 'organizational-unit-find'
                            },
                            {
                                condition: function () {
                                    return (auth.getOrganizationId() !== '' && (auth.isInRole('PROCESSMETADATA READ') || auth.isInRole('PROCESSMETADATA WRITE')));
                                },
                                text: 'MenuMetadata',
                                state: 'metadata-find'
                            },
                            {
                                condition: function () {
                                    return auth.isInRole('APPLICATION INFORMATION');
                                },
                                text: 'MenuStatus',
                                state: 'status-info'
                            },
                            {
                                condition: function () {
                                    return (auth.getOrganizationId() !== '' && auth.isInRole('PROCESS ASYNC'));
                                },
                                text: 'MenuProcessBatch',
                                state: 'process-batch-find'
                            },
                            {
                                condition: function () {
                                    return auth.isInRole('ENABLE ARANDANOS UI');
                                },
                                text: 'MenuArandanosRedirectOptions',
                                state: 'user-arandanos-find'
                            }
                        ]
                    }, -1);

                    navMenu.addItem({
                        condition: function () {
                            return (auth.getOrganizationId() !== '' &&
                                (auth.isInRole('NOTIFICATION READ')
                                || auth.isInRole('PAYCHECKCUSTOMER READ')
                                || auth.isInRole('CERTIFICATECUSTOMER READ')));
                        },
                        text: 'MenuEmployee',
                        items: [
                            {
                                condition: function () {
                                    return auth.isInRole('PAYCHECKCUSTOMER READ');
                                },
                                text: 'MenuEmployeeMyPaychecks',
                                state: 'paycheck-find'
                            },
                            {
                                condition: function () {
                                    return auth.isInRole('CERTIFICATECUSTOMER READ');
                                },
                                text: 'MenuEmployeeMyCertificates',
                                state: 'certificate-find'
                            },
                            {
                                condition: function () {
                                    return auth.isInRole('DOCUMENTCUSTOMER READ');
                                },
                                text: 'MenuEmployeeMyDocuments',
                                state: 'document-find'
                            },
                            {
                                condition: function () {
                                    return auth.isInRole('NOTIFICATION READ');
                                },
                                text: 'MenuEmployeeMyNotifications',
                                state: 'notification-find'
                            }
                        ]
                    }, -1);

                    navMenu.addItem({
                        condition: function () {
                            return (auth.getOrganizationId() !== '' &&
                             (auth.isInRole('EMPLOYEEFILE READ')
                                || auth.isInRole('PAYCHECK READ')
                                || auth.isInRole('DOCUMENT READ')
                                || auth.isInRole('CERTIFICATE READ')
                                || auth.isInRole('EMPLOYEEFILE MULTIPLE WRITE')
                                || auth.isInRole('PAYCHECK MULTIPLE DELETE')
                                || auth.isInRole('PAYCHECK MULTIPLE SIGN')
                                || auth.isInRole('PAYCHECK MULTIPLE CANCEL')));
                        },
                        text: 'MenuRRHH',
                        items: [
                            {
                                condition: function () {
                                    return auth.isInRole('EMPLOYEEFILE ADM')
                                },
                                text: 'MenuRRHHFileFind',
                                state: 'employee-file-find'
                            },
                            {
                                condition: function () {
                                    return auth.isInRole('PAYCHECK READ');
                                },
                                text: 'MenuRRHHImportQueryPayCheck',
                                state: 'paycheck-rrhh-find'
                            },
                            {
                                condition: function () {
                                    return auth.isInRole('DOCUMENT READ');
                                },
                                text: 'MenuAdminDocumentsRRHHTitle',
                                state: 'document-rrhh-find'
                            },
                            {
                                condition: function () {
                                    return auth.isInRole('CERTIFICATE READ');
                                },
                                text: 'MenuRRHHEmployeeFileCertificateFind',
                                state: 'employee-file-certificate-find'
                            },
                            {
                                condition: function () {
                                    return auth.isInRole('EMPLOYEEFILE MULTIPLE WRITE')
                                },
                                text: 'MenuRRHHEmployeeFileMassiveImport',
                                state: 'employee-file-massive-import-find'
                            }
                        ]
                    }, -1);

                    navMenu.addItem({
                        condition: function () {
                            return (auth.isInRole('PAYCHECK TEST')
                            );
                        },
                        text: 'MenuImplementer',
                        items: [
                            {
                                condition: function () {
                                    return (auth.isInRole('PAYCHECK TEST'));
                                },
                                text: 'MenuImplementerPaycheckTest',
                                state: 'paycheck-test-add'
                            }
                        ]
                    }, -1);

                    navMenu.addItem({
                        condition: function () {
                            return auth.isInRole('GO TO EDR');
                        },
                        text: 'IrAEdr',
                        fn: 'createCORSRequest'
                    }, -1);

                    if (auth.isLogged()) {
                        auth.rolesInAllOus().then(function (result) {
                            var items = [];

                            if (result) {

                                angular.forEach(result, function (userOu) {
                                    if (some(["EMPLOYEE"], userOu.roles)) {
                                        items.push({
                                            text: 'Ver mis recibos ' + userOu.organizationalUnit.name,
                                            fn: 'goToNewUI(' + userOu.userId + ')'
                                        });
                                    }
                                    if (some(["EMPLOYER", "RSD", "FIRMANTE"], userOu.roles)) {
                                        items.push({
                                            text: 'Administrar Legajo Digital ' + userOu.organizationalUnit.name,
                                            fn: 'goToNewUI(' + userOu.userId + ')'
                                        });
                                    }

                                });

                                navMenu.addItem({
                                    condition: function () {
                                        return (auth.isLogged());
                                    },
                                    text: 'IrArandano',
                                    items: items
                                }, -1);

                            }
                        });
                    }
                }

                function some (values, array) {

                    for (var i = 0; i < array.length; i++) {
                        if (values.indexOf(array[i]) >= 0) {
                            return true;
                        }
                    }

                    return false;
                };

                auth.onIdentityChanged(function () {

                    menu();
                });

                menu();
            }
        ]);
})();